export default {
  cantFindAddress: 'ไม่พบที่อยู่?',
  confirmLocation: 'ยืนยันสถานที่',
  noResultFound: 'ไม่พบผลลัพธ์!'
};